<template>
  <v-container fluid>
    <validation-observer ref="observer" v-slot="{ invalid }">
      <v-row>
        <v-col cols="12" class="pb-2">
          <base-material-card
            color="primary"
            icon="mdi-file-multiple-outline"
            :title="title"
            inline
            class="px-5 py-4 ml-0"
          >
            <v-row>
              <v-col cols="12" class="pb-0">
                <validation-provider v-slot="{ errors }" rules="required">
                  <v-text-field
                    label="Nome"
                    outlined
                    :error-messages="errors"
                    v-model="nome"
                    class="pt-5"
                    id="titulo-validacao-sdi"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pt-0 pb-0">
                <v-alert
                  dense outlined 
                  type="info" color="blue" 
                  class="mb-0 py-1 px-1"
                >
                  Arquivos permitidos: <b>csv, xlsx, xls, xlsb, txt, zip</b>
                  <br>
                  Tamanho máximo dos arquivos: <b>{{uploadMaxFilesize}}</b>
                </v-alert>
              </v-col>
            </v-row>
              <upload-files
                id="upload-files-valid-sdi"
                @file:uploaded="handleFileUploaded"
                :extensoesPermitidas="['.csv', '.xlsx', '.xls', '.xlsb', '.txt', '.zip']"
                :customFunctionUpload="require('../../services/ValidacoesSdiService.js').default.uploadFile"
              />
              <mapeamento-files
                v-if="uploadedFiles.length > 0"
                ref="refMapeamentos"
                :uploadedFiles="uploadedFiles"
                @rechargeTable="getAllfiles()"
                @mapeamento:apagar-arquivo="handleMapeamentoArquivoApagado"
              />
          </base-material-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            id="btn-save-validacao-sdi"
            color="green"
            min-width="100"
            style="float: right"
            class="mt-n5"
            @click="salvar()"
            :disabled="invalid"
            :loading="loading"
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
      <!-- Exige que tenha no minimo 1 arquivo mapeado para prosseguir com a validação -->
      <validation-provider v-slot="{ errors }" rules="min_value:1">
        <input type="hidden" :value="uploadedFiles.length" :error-messages="errors" />
      </validation-provider>
    </validation-observer>
  </v-container>
</template>

<script>
import ValidacoesSdiService from "@/services/ValidacoesSdiService";
import ServerConfigService from "@/services/ServerConfigService";
import tourMixins from '@/mixins/tourMixins';

export default {
  mixins: [tourMixins],

  components: {
    UploadFiles: () => import('@/components/general/UploadFiles'),
    MapeamentoFiles: () => import('@/components/validacoesSdi/MapeamentoFiles'),
  },

  created() {
    this.getPhpConfig();
  },

  mounted() {
    this.iniciarTourPagina();
  },

  data: () => ({
    nome: "",
    loading: false,
    uploadedFiles: [],
    uploadMaxFilesize: '...',
    postMaxSize: null,
    maxExecutionTime: null,
    maxInputTime: null,
    arrTour: [
      {
        element: '#titulo-validacao-sdi',
        intro: 'Aqui você deverá inserir um nome para sua validação de sdi.',
        scrollTo: "tooltip",
        position: 'right'
      }, 
      {
        element: '#upload-files-valid-sdi',
        intro: 'Aqui você deverá carregar os arquivos que serão utilizados na validação de SDI e posteriormente criar um mepeamento, indicando quais validações serão aplicadas.',
        scrollTo: "tooltip",
        position: 'right'
      },
      {
        element: '#btn-save-validacao-sdi',
        intro: 'Após seleção dos critérios anteriores, clique aqui para salvar e executar sua validação de sdi.',
        scrollTo: "tooltip",
        position: 'left'
      }
    ]
  }),

  computed: {
    title() {
      return this.$route.params.id ? "Editando Validação de SDI" : "Adicionar Validação de SDI";
    },
  },

  methods: {
    getPhpConfig() {
      ServerConfigService
        .getPhpConfig()
        .then(response => {
          const { uploadMaxFilesize, postMaxSize, maxExecutionTime, maxInputTime } = response.data.info;
          this.uploadMaxFilesize = this.converterUnidades(uploadMaxFilesize);
          this.postMaxSize = this.converterUnidades(postMaxSize); 
          this.maxExecutionTime = maxExecutionTime;
          this.maxInputTime = maxInputTime;  
        })
        .catch(error => console.log('Error: ' + error));
    },

    converterUnidades(input) {
      if (input === null || typeof input !== 'string') return input;

      return input.replace(/G$/, 'GB').replace(/M$/, 'MB');
    },

    handleFileUploaded(event) {
      const files = event.files;
      files.forEach(file => this.uploadedFiles.push(file));
    },

    salvar() {
      this.loading = true;

      let data = {
        id: this.$route.params.id ? this.$route.params.id : null,
        nome: this.nome,
        parametros: JSON.stringify(this.$refs.refMapeamentos.exportData())
      };

      ValidacoesSdiService
        .salvar(data)
        .then(() => {
          this.$toast.success('Validação de SDI salva com sucesso.', '', { position: 'topRight' });
          this.$router.replace({name: 'Validações de SDI Histórico'});
        })
        .catch(() => {
          this.$toast.error('Erro ao salvar validação de SDI.', '', { position: 'topRight' });
        })
        .finally(() => this.loading = false);
    },

    handleMapeamentoArquivoApagado(event) {
      this.uploadedFiles = this.uploadedFiles.filter(item => item.arquivo_id !== event.arquivo_id);
    },

    iniciarTourPagina() {
      if (this.tourFuncCalled) return;

      this.iniciarTour(this.arrTour);
    }
  }
}
</script>